import React from 'react';
import { css } from '@emotion/react';
import Bg from '../../../../assets/home/homeDarkBg.svg';

const slideLeftToRight = css`
    @keyframes slideLeftToRight {
        0% {
            transform: translateX(-180%);
        }
        100% {
            transform: translateX(0%);
        }
    }

    animation: slideLeftToRight 50s linear infinite;
`;

const slideRightToLeft = css`
    @keyframes slideRightToLeft {
        0% {
            transform: translateX(60%);
        }
        100% {
            transform: translateX(0%);
        }
    }

    animation: slideRightToLeft 20s linear infinite;
`;

const darkSectionCss = css`
    background-image: url(${Bg});
    background-size: cover;
    background-position: center;
    position: relative;
    z-index: 1;

    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.70);
        z-index: 2;
    }
`;

const BookCard: React.FC<{ title: string; img: string; genre: string;   likeCnt: string; variant: 'green' | 'blue' | 'purple' | 'default' }> = ({ title, img, genre, likeCnt, variant }) => {

    const baseStyle = css`
        border-radius: 16px;
        border: 0 solid #E5E7EB;
        background: linear-gradient(135deg, #4FDB95 0%, #19CF7A 70.71%);
        box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.25);
        flex-shrink: 0;
    `;

    const greenStyle = css`
        border-radius: 16px;
        border: 0 solid #E5E7EB;
        background: linear-gradient(135deg, #16B96A 0%, #19CF7A 70.71%);
        box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.25);
        flex-shrink: 0;
    `;

    const blueStyle = css`
        border-radius: 16px;
        border: 0 solid #E5E7EB;
        background: linear-gradient(135deg, #6C7B7F 0%, #19CF7A 70.71%);
        box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.25);
        flex-shrink: 0;
    `;

    const purpleStyle = css`
        border-radius: 16px;
        border: 0 solid #E5E7EB;
        background: linear-gradient(135deg, #6C7B7F 0%, #9CA3AF 70.71%);
        box-shadow: 0 25px 50px 0 rgba(0, 0, 0, 0.25);
        flex-shrink: 0;
    `;

    let variantStyle = baseStyle;
    if (variant === 'green') {
        variantStyle = greenStyle;
    } else if (variant === 'blue') {
        variantStyle = blueStyle;
    } else if (variant === 'purple') {
        variantStyle = purpleStyle;
    }


    return (
        <div className="relative w-[203px] md:w-[130px] py-6 px-7 md:py-4 md:px-3 flex flex-col justify-content-center items-center h-[305px] md:h-[199px] z-10 p-2 cursor-pointer transition hover:bg-white/20" css={variantStyle}>
            <div className="flex flex-col  gap-3 md:gap-1 ">
                <img
                    src={img}
                    alt={"이미지"}
                    className="object-cover w-[149px] h-[149px] md:w-[100px] md:h-[100px] rounded-[12px] justify-center items-center cursor-pointer"
                />

                <div className="flex flex-col gap-1 md:gap-0.5">
                    <span className="text-[20px] md:text-sm font-bold text-white truncate w-full">{title}</span>
                    <span className="text-base font-medium md:text-[10px] leading-[20px] opacity-80">{genre}</span>

                    <div className="flex flex-row gap-2 items-center">

                        {variant === 'purple' ? (
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none" className="md:w-[10px] md:h-[10px]">
                                    <path d="M2.51016 9.43799L8.50996 15.6027C8.75898 15.8585 9.0877 16.001 9.42969 16.001C9.77168 16.001 10.1004 15.8585 10.3494 15.6027L16.3492 9.43799C17.3586 8.40384 17.9297 6.95311 17.9297 5.43661V5.22466C17.9297 2.67036 16.2529 0.492437 13.9652 0.0722013C12.4512 -0.20552 10.9105 0.33896 9.82812 1.53024L9.42969 1.96875L9.03125 1.53024C7.94883 0.33896 6.4082 -0.20552 4.89414 0.0722013C2.60645 0.492437 0.929688 2.67036 0.929688 5.22466V5.43661C0.929688 6.95311 1.50078 8.40384 2.51016 9.43799Z" fill="#CFD4D7"/>
                                </svg>

                        ) : (

                            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none" className="md:w-[10px] md:h-[10px]">
                                <path d="M1.58047 9.43701L7.58027 15.6017C7.8293 15.8575 8.15801 16 8.5 16C8.84199 16 9.1707 15.8575 9.41973 15.6017L15.4195 9.43701C16.4289 8.40286 17 6.95213 17 5.43563V5.22369C17 2.66938 15.3232 0.491461 13.0355 0.0712247C11.5215 -0.206497 9.98086 0.337983 8.89844 1.52926L8.5 1.96777L8.10156 1.52926C7.01914 0.337983 5.47852 -0.206497 3.96445 0.0712247C1.67676 0.491461 0 2.66938 0 5.22369V5.43563C0 6.95213 0.571094 8.40286 1.58047 9.43701Z" fill="#B9F0D1"/>
                            </svg>

                        )}


                        <span
                            className={`text-base md:text-xs font-medium ${
                                variant === 'purple' ? 'text-[#CFD4D7]' : 'text-[#D5F6E3]'
                            }`}
                        >{likeCnt}</span>
                    </div>
                </div>
            </div>
        </div>

    );
};

const DarkBackgroundSection: React.FC = () => {


    let bookList = [
        { id: 1,
            title : "오늘을 사는 기술",
            img : "/img/home/book/book1.jpg",
            genre : "에세이",
            like: "98"
        },
        { id: 2,
            title : "작은 것들의 노래",
            img : "/img/home/book/book2.png",
            genre : "시",
            like: "120"
        },
        { id: 3,
            title : "별빛 우체국",
            img : "/img/home/book/book3.png",
            genre : "시",
            like: "72"
        },
        { id: 4,
            title : "마지막 편지",
            img : "/img/home/book/book4.png",
            genre : "소설",
            like: "104"
        },
        { id: 5,
            title : "불확실한 벽을 너머",
            img : "/img/home/book/book5.png",
            genre : "에세이",
            like: "300"
        },
        { id: 6,
            title : "무수한 삶속에서 우린",
            img : "/img/home/book/book6.jpg",
            genre : "인문",
            like: "212"
        },
        { id: 7,
            title : "식물과 나의 하루",
            img : "/img/home/book/book7.png",
            genre : "엽서/일러스트레이션 북",
            like: "116"
        },
        { id: 8,
            title : "기억의 도서관",
            img : "/img/home/book/book8.jpg",
            genre : "소설",
            like: "98"
        },
        { id: 9,
            title : "계절을 쓰다",
            img : "/img/home/book/book9.png",
            genre : "엽서/일러스트레이션 북",
            like: "98"
        },
        { id: 10,
            title : "5시간 투자 습관",
            img : "/img/home/book/book10.jpg",
            genre : "자기계발",
            like: "120"
        },
        { id: 11,
            title : "오늘을 견디는 한 줄",
            img : "/img/home/book/book11.png",
            genre : "엽서/일러스트레이션 북",
            like: "206"
        },
        { id: 12,
            title : "물고기의 꿈",
            img : "/img/home/book/book12.jpg",
            genre : "소설",
            like: "104"
        },
        { id: 13,
            title : "오후 다섯 시가 되면",
            img : "/img/home/book/book13.jpg",
            genre : "소설",
            like: "168"
        },
    ]



    const firstBooks = bookList.slice(0, 7); // 앞의 7권
    const secondBooks = bookList.slice(7);   // 그 이후 책들

    const getVariant = (index: number): 'green' | 'blue' | 'purple' | 'default' => {
        if (index === 0) return 'green';
        if (index === 1) return 'purple';
        if (index === 4) return 'blue';
        return 'default';
    };



    return (
        <section css={darkSectionCss} className="py-20 px-4  md:px-8 text-white ">
            <div className="relative z-10 max-w-7xl mx-auto flex flex-col gap-8 md:gap-[30px]">
                <div className={"flex flex-col justify-center gap-3"}>
                    <span className="text-[36px] md:text-[22px] text-white font-bold text-center  leading-[28px]">
                        책 밖에서도 <br className="hidden md:block"/> 당신의 이야기는 계속됩니다.
                    </span>
                    <span className={"text-white text-center text-[20px] font-normal md:text-base"}>
                        출간 계기와 작품의 핵심 키워드를 통해 <br />
                        작품 내용을 재미있게 전달해 보세요!
                    </span>
                </div>

                <div className={"flex flex-col gap-4 "}>

                        <div
                            className="flex gap-3 sm:gap-4  relative"
                            css={slideRightToLeft}
                        >

                            {[...firstBooks, ...firstBooks].map((book, index) => (
                                <BookCard
                                    key={`${book.id}-${index}`}
                                    title={book.title}
                                    img={book.img}
                                    genre={book.genre}
                                    likeCnt={book.like}
                                    variant={getVariant(index)}
                                />
                            ))}

                        </div>

                    <div
                        className="flex gap-3 sm:gap-4  relative"
                        css={slideLeftToRight}
                    >


                        {[...secondBooks, ...secondBooks].map((book, index) => (

                            <BookCard
                                key={`${book.id}-${index}`}
                                title={book.title}
                                img={book.img}
                                genre={book.genre}
                                likeCnt={book.like}
                                variant={getVariant(index)}
                            />
                        ))}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default DarkBackgroundSection;
